(() => {
  'use strict';
  if (window.ucwCollectionImagesInitialized) return;
  window.ucwCollectionImagesInitialized = true;
  const initialized = new WeakSet();
  function init(dialog) {
    if (initialized.has(dialog)) return;
    initialized.add(dialog);
    const trigger = document.querySelector('[data-ucw-collection-image-open][aria-controls="' + dialog.id + '"]');
    const image = dialog.querySelector('[data-ucw-collection-image]'), error = dialog.querySelector('[data-ucw-collection-image-error]');
    let previousOverflow = '';
    trigger?.addEventListener('click', () => {
      if (dialog.open) return;
      previousOverflow = document.documentElement.style.overflow;
      dialog.showModal(); document.documentElement.style.overflow = 'hidden';
      if (!image.getAttribute('src')) image.src = image.dataset.src;
    });
    image.addEventListener('error', () => { image.hidden = true; error.hidden = false; });
    dialog.querySelector('[data-ucw-collection-image-close]').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const r = dialog.getBoundingClientRect();
      if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) dialog.close();
    });
    dialog.addEventListener('close', () => { document.documentElement.style.overflow = previousOverflow; if (trigger?.isConnected) trigger.focus({ preventScroll: true }); });
    dialog.closest('.shopify-section')?.addEventListener('shopify:section:unload', () => { if (dialog.open) dialog.close(); });
  }
  const scan = (root = document) => root.querySelectorAll('[data-ucw-collection-image-dialog]').forEach(init);
  scan(); document.addEventListener('DOMContentLoaded', () => scan(), { once: true });
  document.addEventListener('shopify:section:load', event => scan(event.target));
})();
